export default __webpack_public_path__ + "static/media/DSC_0820.1e60e40a.JPG";